/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-inner-declarations */
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import moment from 'moment';
import {
  Table,
  FlexboxGrid,
  SelectPicker,
  Col,
  Loader,
  CheckPicker,
  Toggle,
  IconButton,
} from 'rsuite';
import { Copy, Edit } from '@rsuite/icons';
import { toast } from 'react-toastify';
import { eachDayOfInterval, format, parseISO } from 'date-fns';
import { Container } from '~/styles/tabela1';
import SearchInputTable from '~/components/SearchInputTable';
import api from '~/services/api';
import { TableHeaderTooltip, TablePagination } from '~/components/TablePagination1';
import { ButtonBorderBlue } from '~/components/Buttons/ButtonBorderBlue/styles';
import CelulaAcao from '~/components/Celulas/components/CelulaAcao';
import { MdOutlinePeopleOutline } from 'react-icons/md';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { TbCertificate } from 'react-icons/tb';
import { FaRegStar } from 'react-icons/fa';
import { CardConfirmacao } from './components/CardConfirmacao';
import EditarPedido from '../EditarPedido';

import { Row, ToggleRetorno } from './styles';
import { InputDataRange } from '../../../components/InputDataRange';
import ModalEnviarNotificacao from './ModalEnviarNotificacao';
import PageHeader from '../../../components/PageHeader';
import MetricsCards from '../../../components/MetricCards';
import AdvancedFilters from '../../../components/AdvancedFilters';

const { HeaderCell, Column, Cell } = Table;

function RetornoConfirmacoes() {
  const [filtroData, setFiltroData] = useState();
  const [datas, setDatas] = useState();
  const [confirmacoes, setConfirmacoes] = useState({
    lista: [],
    quantidade: 0,
  });
  const [confirmacoesFeitasOuNaoFeitas, setConfirmacoesFeitasOuNaoFeitas] =
    useState();
  const [toDoOrDone, setToDoOrDone] = useState(0);
  const [pagina, setPagina] = useState(1);
  const [carregando, setCarregando] = useState(false);
  const [estados, setEstados] = useState([]);
  const [estadoSelecionado, setEstadoSelecionado] = useState();
  const [estabDigitado, setEstabDigitado] = useState();
  const [proDigitado, setProDigitado] = useState();

  const [profissoes, setProfissoes] = useState([]);

  const [servicoSelecionado, setServicoSelecionado] = useState([]);
  const [pedidoEditando, setPedidoEditando] = useState();
  const [filtroCidades, setFiltroCidades] = useState();
  const [showEditarPedido, setShowEditarPedido] = useState(false);

  const locale = {
    sunday: 'Dom',
    monday: 'Seg',
    tuesday: 'Ter',
    wednesday: 'Qua',
    thursday: 'Qui',
    friday: 'Sex',
    saturday: 'Sab',
    ok: 'Ok',
    today: 'Hoje',
    yesterday: 'Ontem',
    hours: 'Horas',
    minutes: 'Minutos',
    seconds: 'Segundos',
  };

  const [orderBy, setOrderBy] = useState('');
  // 'order by reg.hora_inicio asc, pro.nome asc'

  const buscarRelatorios = useCallback(async () => {
    setCarregando(true);
    try {
      const resposta = await api.get('registros/service-confirmations', {
        params: {
          pagina,
          orderBy,
          data: datas,
          estado: estadoSelecionado,
          profissional: proDigitado,
          estabelecimento: estabDigitado,
          cidade: filtroCidades,
          servicos: servicoSelecionado,
          pro_confirmation: toDoOrDone,
        },
      });

      setConfirmacoesFeitasOuNaoFeitas(resposta.data.confirmations);

      const listaFormatada = resposta.data.lista.map((registros) => ({
        ...registros,
        id: registros.id,
        nome: registros.profissional && registros.profissional.nome,
        nome_fantasia: registros.pedido.estabelecimento.nome_fantasia,
        profissao: registros.profissao.profissao,
        data: format(parseISO(registros.data), 'dd/LL/yyyy'),
        dataOriginal: registros.data,
        horario_popup:
          registros.horario_popup !== null
            ? moment(registros.horario_popup).format('DD/MM/YYYY | HH:mm')
            : '',
        horario_confirmacao:
          registros.horario_confirmacao !== null
            ? moment(registros.horario_confirmacao).format('DD/MM/YYYY | HH:mm')
            : '',
        inicio: format(new Date(registros.hora_inicio), 'HH:mm'),
        fim: format(new Date(registros.hora_fim), 'HH:mm'),
        cidade: registros.endereco.bairro.cidade.cidade,
        estado: registros.endereco.bairro.cidade.estado.uf,
        pro_confirmation: registros.pro_confirmation,
        id_pedido: registros.pedido.id,
        // Dados adicionais para cópia
        hora_inicio: registros.hora_inicio,
        hora_fim: registros.hora_fim,
        intervalo: registros.pedido.intervalo,
        valor: registros.valor,
        refeicao: registros.pedido.estabelecimento.refeicao,
        uniforme: registros.pedido.uniforme,
        endereco_completo: registros.endereco,
        nome_estado: registros.endereco.bairro.cidade.estado.estado,
        bairro: registros.endereco.bairro.bairro,
      }));

      let resulServise = [];
      if (resposta.data.lista && resposta.data.lista.length > 0) {
        resulServise =
          resposta.data.lista &&
          resposta.data.lista.map((servico) => ({
            label: servico.profissao.profissao,
            value: servico.profissao.id,
          }));
      }

      setConfirmacoes({
        lista: listaFormatada,
        quantidade: resposta.data.quantidade,
        servico: resulServise,
      });
      if (confirmacoes.quantidade > 0 && confirmacoes.lista.length === 0)
        setPagina(1);

      const estados1 = await api.get('estado');
      setEstados(estados1.data);
    } catch (e) {
      toast.error(e.message);
    }
    setCarregando(false);
  }, [
    pagina,
    datas,
    estadoSelecionado,
    toDoOrDone,
    estabDigitado,
    proDigitado,
    servicoSelecionado,
    filtroCidades,
    orderBy,
    confirmacoes.quantidade,
    confirmacoes.lista.length,
    setPagina,
  ]);

  useEffect(() => {
    buscarRelatorios();
  }, [buscarRelatorios]);

  useEffect(() => {
    const buscarDadosApi = async () => {
      try {
        const resposta = await api.get('profissao');
        setProfissoes(resposta.data);
      } catch (error) {
        toast.error(error.message);
      }
    };

    buscarDadosApi();
  }, []);

  function abrirEditarPedido(pedido) {
    setPedidoEditando(pedido);
    setShowEditarPedido(true);
  }

  function fecharEditarPedido() {
    buscarRelatorios();
    setShowEditarPedido(false);
  }

  async function alteracaoRetorno(e, value) {
    try {
      const returnValue2 = {
        pro_confirmation: !value,
      };
      setCarregando(true);
      await api.patch(`registros/service-confirmations/${e.id}`, returnValue2);
      setCarregando(false);
      buscarRelatorios();
      toast.success('Confirmação atualizada com sucesso');
    } catch (err) {
      toast.error(err.message);
    }
  }

  const CelulaAcaoRetorno = ({ rowData, ...props }) => (
    <Cell {...props}>
      <ToggleRetorno>
        <Toggle
          checkedChildren="Feito"
          unCheckedChildren="A Fazer"
          defaultChecked={rowData.pro_confirmation}
          onChange={() => alteracaoRetorno(rowData, rowData.pro_confirmation)}
        />
      </ToggleRetorno>
    </Cell>
  );

  function copiarInformacoesServico(rowData) {
    try {
      console.log('Dados do rowData:', rowData);

      // Formatar uniformes
      let uniformeTexto = 'Não informado';
      if (rowData.uniforme) {
        const uniformes = [];
        if (rowData.uniforme.blusa) uniformes.push(`*Blusa:* ${rowData.uniforme.blusa}`);
        if (rowData.uniforme.calca) uniformes.push(`*Calça:* ${rowData.uniforme.calca}`);
        if (rowData.uniforme.calcado) uniformes.push(`*Calçado:* ${rowData.uniforme.calcado}`);
        if (uniformes.length > 0) {
          uniformeTexto = uniformes.join(', ');
        }
      }

      // Formatar endereço
      let enderecoCompleto = 'Não informado';
      if (rowData.endereco_completo) {
        const { logradouro, numero } = rowData.endereco_completo;
        enderecoCompleto = `${logradouro || ''}, ${numero || ''}. ${rowData.bairro || ''} - ${rowData.cidade || ''} / ${rowData.nome_estado || ''}`;
      }

      // Formatar valores
      const repasse = rowData.valor ? `R$ ${parseFloat(rowData.valor).toFixed(2).replace('.', ',')}` : 'Não informado';
      const refeicao = rowData.refeicao ? 'Sim' : 'Não';

      // Formatar intervalo (pode ser número em minutos ou já estar formatado)
      let intervalo = '00:00';
      if (rowData.intervalo) {
        if (typeof rowData.intervalo === 'number') {
          const horas = Math.floor(rowData.intervalo / 60);
          const minutos = rowData.intervalo % 60;
          intervalo = `${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}`;
        } else {
          intervalo = rowData.intervalo;
        }
      }

      const nomeEstabelecimento = rowData.nome_fantasia || 'Não informado';
      const servico = rowData.profissao || 'Não informado';
      const dataFormatada = rowData.dataOriginal ? format(parseISO(rowData.dataOriginal), 'dd/MM/yyyy') : 'Não informado';
      const horaInicio = rowData.hora_inicio ? format(new Date(rowData.hora_inicio), 'HH:mm') : 'Não informado';
      const horaFim = rowData.hora_fim ? format(new Date(rowData.hora_fim), 'HH:mm') : 'Não informado';

      const textoFormatado = `*Nome:* ${nomeEstabelecimento}
*Serviço:* ${servico}
*Data:* ${dataFormatada}
*Horário Início:* ${horaInicio}
*Horário Fim:* ${horaFim}
*Intervalo:* ${intervalo}
*Repasse:* ${repasse}
*Uniforme:* ${uniformeTexto}
*Endereço:* ${enderecoCompleto}
*Fornece refeição?:* ${refeicao}`;

      navigator.clipboard.writeText(textoFormatado);
      toast.success('Informações copiadas para a área de transferência!');
    } catch (error) {
      console.error('Erro completo:', error);
      console.error('Erro mensagem:', error.message);
      toast.error(`Erro ao copiar informações: ${error.message}`);
    }
  }

  const CelulaAcaoComCopiar = ({ rowData, ...props }) => (
    <Cell {...props} style={{ padding: '5px' }}>
      <div style={{ display: 'flex', gap: '5px', justifyContent: 'center' }}>
        <IconButton
          appearance="subtle"
          size="sm"
          icon={<Copy />}
          onClick={() => copiarInformacoesServico(rowData)}
          title="Copiar informações"
        />
        <IconButton
          appearance="subtle"
          size="sm"
          icon={<Edit />}
          onClick={() => abrirEditarPedido(rowData)}
          title="Editar"
        />
      </div>
    </Cell>
  );

  const activeFilters = useMemo(() => {
    const filters = [];
    return filters;
  }, []);

  return (
    <Container>
      <PageHeader
        title="Confirmações dos Serviços"
        subtitle="Relatorio de confirmações dos serviços."
      />

      <AdvancedFilters
        activeFilters={activeFilters}
        header={
          <>
            <InputDataRange
              // cleanable={false}
              style={{ marginRight: '0px', width: '100px' }}
              ranges={[]}
              isoWeek
              // oneTap
              locale={locale}
              value={datas}
              onChange={setDatas}
            />
          </>
        }
      >

        <FlexboxGrid style={{ gap: '10px' }} justify="start">

          <FlexboxGrid.Item as={Col} col={4}>
            <SelectPicker
              appearance="default"
              // style={{ marginRight: '15px' }}
              placeholder="Estado"
              data={estados.map((estado) => ({
                label: estado.uf,
                value: estado.id,
              }))}
              value={estadoSelecionado}
              onChange={(value) => setEstadoSelecionado(value)}
            />
          </FlexboxGrid.Item>
          <SearchInputTable
            setTextoDigitado={setProDigitado}
            place="Profissional"
            estilo={{
              width: '200px',
            }}
          />
          <SearchInputTable
            setTextoDigitado={setEstabDigitado}
            estilo={{
              width: '200px',
            }}
            place="Estabelecimento"
          />
          <SearchInputTable
            setTextoDigitado={setFiltroCidades}
            estilo={{
              width: '200px',
            }}
            place="Cidade"
          />
          <CheckPicker
            style={{ width: 193 }}
            appearance="default"
            placeholder="Serviços"
            data={profissoes.map((p) => {
              return {
                label: p.profissao,
                value: p.id,
              };
            })}
            value={servicoSelecionado}
            onChange={(value) => setServicoSelecionado(value)}
          />
          <ModalEnviarNotificacao />

          {/* <ButtonBorderBlue appearance="ghost" onClick={efetuarTeste}>Teste</ButtonBorderBlue> */}
        </FlexboxGrid>
      </AdvancedFilters>
      <FlexboxGrid>
        <FlexboxGrid.Item as={Col} col={16}>
          <Row style={{ width: '246px' }}>
            <CardConfirmacao
              done={
                (confirmacoesFeitasOuNaoFeitas &&
                  confirmacoesFeitasOuNaoFeitas[0].done) ||
                0
              }
              toDo={
                (confirmacoesFeitasOuNaoFeitas &&
                  confirmacoesFeitasOuNaoFeitas[0].to_do) ||
                0
              }
              setToDoOrDone={setToDoOrDone}
              toDoOrDone={toDoOrDone}
            />
          </Row>
        </FlexboxGrid.Item>
      </FlexboxGrid>
      <FlexboxGrid style={{ width: '100%', marginTop: '10px' }}>
        <TablePagination
          carregando={carregando}
          dados={confirmacoes.lista}
          quantidade={confirmacoes.quantidade}
          onChangePage={setPagina}
          setOrderBy={setOrderBy}
        >
          <Column resizable width={90}>
            <HeaderCell>
              <TableHeaderTooltip label="Ações" tooltip="Ações" />
            </HeaderCell>
            <CelulaAcaoComCopiar dataKey="id" />
          </Column>
          <Column resizable width={190} sortable>
            <HeaderCell>
              <TableHeaderTooltip label="Nome" tooltip="Nome" />
            </HeaderCell>
            <Cell dataKey="nome" />
          </Column>
          <Column resizable width={150} sortable>
            <HeaderCell>
              <TableHeaderTooltip label="Estabelecimento" tooltip="Estabelecimento" />
            </HeaderCell>
            <Cell dataKey="nome_fantasia" />
          </Column>
          <Column resizable width={150} sortable>
            <HeaderCell>
              <TableHeaderTooltip label="Serviços" tooltip="Serviços" />
            </HeaderCell>
            <Cell dataKey="profissao" />
          </Column>
          <Column resizable width={150} sortable>
            <HeaderCell>
              <TableHeaderTooltip label="Data" tooltip="Data" />
            </HeaderCell>
            <Cell dataKey="data" />
          </Column>

          <Column resizable width={70}>
            <HeaderCell>
              <TableHeaderTooltip label="Inicio" tooltip="Inicio" />
            </HeaderCell>
            <Cell dataKey="inicio" />
          </Column>

          <Column resizable width={70}>
            <HeaderCell>
              <TableHeaderTooltip label="Fim" tooltip="Fim" />
            </HeaderCell>
            <Cell dataKey="fim" />
          </Column>

          <Column resizable width={120} sortable>
            <HeaderCell>
              <TableHeaderTooltip label="Cidade" tooltip="Cidade" />
            </HeaderCell>
            <Cell dataKey="cidade" />
          </Column>
          <Column resizable width={120} sortable>
            <HeaderCell>
              <TableHeaderTooltip label="Estado" tooltip="Estado" />
            </HeaderCell>
            <Cell dataKey="estado" />
          </Column>
          <Column resizable width={170}>
            <HeaderCell>
              <TableHeaderTooltip label="Horário Popup" tooltip="Horário Popup" />
            </HeaderCell>
            <Cell dataKey="horario_popup" />
          </Column>
          <Column resizable width={170}>
            <HeaderCell>
              <TableHeaderTooltip label="Horário Confirmação" tooltip="Horário Confirmação" />
            </HeaderCell>
            <Cell dataKey="horario_confirmacao" />
          </Column>
          <Column resizable width={100} sortable>
            <HeaderCell>
              <TableHeaderTooltip label="Retorno" tooltip="Retorno" />
            </HeaderCell>
            <CelulaAcaoRetorno dataKey="pro_confirmation" />
          </Column>
        </TablePagination>
      </FlexboxGrid>

      <EditarPedido
        idPedido={pedidoEditando && pedidoEditando.id_pedido}
        showEditarPedido={showEditarPedido}
        // codPedido={pedidoEditando && pedidoEditando.numero_pedido}
        setShowEditarPedido={setShowEditarPedido}
        fecharEditarPedido={fecharEditarPedido}
      />
    </Container>
  );
}

export default RetornoConfirmacoes;
